import dayjs from "dayjs";
import React from "react";
//Term
export const termoptions = [
  { label: "30 year", value: 30 },
  { label: "25 year", value: 25 },
  { label: "20 year", value: 20 },
  { label: "15 year", value: 15 },
  { label: "10 year", value: 10 },
];
//action of Notice
export const actionNotice_item1 = "NoticeofIncompleteApplication";
export const actionNotice_item2 = "NoticeofCounterOffer";
export const actionNotice_item3 = "NoticeofwithdrawnApplication";
export const actionNotice_item4 = "NoticeofCreditDenial";
export const actionNoticeOptions = [
  {
    value: actionNotice_item1,
    label: "Notice of Incomplete Application",
  },
  {
    value: actionNotice_item2,
    label: "Notice of Counter Offer",
  },
  {
    value: actionNotice_item3,
    label: "Notice of withdrawn Application",
  },
  {
    value: actionNotice_item4,
    label: "Notice of Credit Denial",
  },
];

// hmdaActionTaken
export const actionTaken_item1 = 'AppApprovedButNotAcceptedByApplicant';
export const actionTaken_item2 = 'ApplicationDenied';
export const actionTaken_item3 = 'ApplicationWithdrawn';
export const actionTaken_item4 = 'FileClosedForIncompleteness';
export const actionTaken_item5 = 'LoanPurchasedByYourInstitution';
export const actionTaken_item6 = 'PreapprovalRequestDeniedByFinancialInstitution';
export const actionTaken_item7 = 'PreapprovalRequestApprovedButNotAcceptedDate';
export const hmdaActionTakenOptions = [
  {
    value: actionTaken_item1,
    label: "App approved but not accepted by applicant",
  },
  { value: actionTaken_item2, label: "Application denied" },
  { value: actionTaken_item3, label: "Application withdrawn" },
  {
    value: actionTaken_item4,
    label: "File closed for incompleteness",
  },
   {
    value: actionTaken_item5,
    label: "Loan purchased by your institution",
  },
  {
    value: actionTaken_item6,
    label: "Preapproval request denied by financial institution"
  },
  {
    value: actionTaken_item7,
    label: "Preapproval request approved but not accepted date",
  },
];

// suffix
export const suffixOptions = [
  { value: "", label: "-- No Suffix --" },
  { value: "Jr.", label: "Jr." },
  { value: "Sr.", label: "Sr." },
  { value: "I", label: "I" },
  { value: "II", label: "II" },
  { value: "III", label: "III" },
  { value: "IV", label: "IV" },
  { value: "Ph.D.", label: "Ph.D." },
  { value: "M.D.", label: "M.D." },
  { value: "Esq.", label: "Esq." },
  { value: "J.D.", label: "J.D." },
  { value: "CPA", label: "CPA" },
  { value: "DDS", label: "DDS" },
  { value: "KBE", label: "KBE" },
  { value: "OBE", label: "OBE" },
  { value: "MBE", label: "MBE" },
];

// method
export const methodOptions = [
  { label: "Mail", value: "mail" },
  { label: "E-mailed", value: "eMailed" },
  { label: "Hand delivered", value: "handDelivered" },
];

//时间格式化 - notice页面初始化时间和提交表单更改时间
export const getFormatInfo = (
  data,
  isFormat = true,
  formatStr = "MM/DD/YYYY"
) => {
  const formatValue = (v) => {
    if (!v) return '';
    return isFormat ? dayjs(v).format(formatStr) : dayjs(v, formatStr);
  };
  
  data?.dateDenied && (data.dateDenied = formatValue(data.dateDenied));
  data?.actionDate && (data.actionDate = formatValue(data.actionDate));
  data?.counterOfferExpires &&
    (data.counterOfferExpires = formatValue(data.counterOfferExpires));
  // data?.borrower?.dateIssued &&
  //   (data.borrower.dateIssued = formatValue(data.borrower.dateIssued));
  // data?.coborrower?.dateIssued &&
  //   (data.coborrower.dateIssued = formatValue(data.coborrower.dateIssued));
  data?.deliveryDate && (data.deliveryDate = formatValue(data.deliveryDate));

  if (data?.disclosureOfUseOfInformation) {
    let arr = data?.disclosureOfUseOfInformation || [];
    data.disclosureOfUseOfInformation[0].dateIssued = formatValue(
      arr?.[0]?.dateIssued
    );
    data.disclosureOfUseOfInformation[1].dateIssued = formatValue(
      arr?.[1]?.dateIssued
    );
  }
  return data;
};
// 日期icon
export const dateSuffixIcon = (
  <img style={{ width: 24, height: 24, pointerEvents: 'none' }} src="/images/date.svg"/>
);
